import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {Box, Divider, IconButton, Tooltip} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {ExportField} from '../../interfaces/Export';
import ExportPdfButton from '../common/ExportPdfButton';
import ModalFixed from '../common/ModalFixed';
import WifiPointTrackingExportExcel from '../dashboard-panels/CommtracNodeTrackingReports/WifiPointTrackingExportExcel';
import {WifiPointHistoryReportsData} from '../dashboard-panels/NodeTrackingReports/WifiPointHistoryReports';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  value?: WifiPointHistoryReportsData;
  exportFields?: ExportField[];
  onSubmitted?: () => void;
}

const WifiPointHistoryTrackingReportExportButton = <T extends ComponentType>({
  componentProps,
  children,
  exportFields,
}: Props<T>) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <FileDownloadIcon {...componentProps} onClick={() => setIsOpened(true)}>
          {children}
        </FileDownloadIcon>
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <FileDownloadIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export History</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <WifiPointTrackingExportExcel
                value={{
                  ...componentProps,
                }}
                exportFields={exportFields}
              />
              <ExportPdfButton
                endpoint={`/node/${componentProps?.id}/wifi-point/events`}
                defaultFilename="wifi_point_history.pdf"
                params={{
                  date_start: componentProps?.date_start,
                  date_end: componentProps?.date_end,
                }}
                exportFields={exportFields}
              />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default WifiPointHistoryTrackingReportExportButton;
